const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB;

const hasValue = (value) => value !== null && value !== undefined && value !== "";

const boPathId = (value) => String(value).replace("/", "-");

export const activityLinkUrl = {
    garrison: (id) => hasValue(id)
        ? {dev: `${API_DESPACHO_WEB}/garrison/form/${id}`}
        : null,
    dispatch: (id) => hasValue(id)
        ? {dev: `${API_DESPACHO_WEB}/dispatch/form/${id}`}
        : null,
    bo: (id) => hasValue(id)
        ? {dev: `/bo/redirect/${boPathId(id)}`}
        : null,
    encounter: (id) => hasValue(id)
        ? {dev: `/encounter/form/${id}`}
        : null,
};

export const brDateToIso = (value) => {
    if (!value) return "";
    const [dd, mm, yyyy] = value.split("/");
    if (!dd || !mm || !yyyy) return "";
    return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
};

export const formatDateTime = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const extractInspectors = (garrison) => {
    const savedInspectors = garrison.savedInspectors ?? [];
    return (garrison.composition ?? [])
        .flatMap(item => item.integrants ?? [])
        .filter(integrant => integrant.contingent?.rank === "INSPETOR")
        .map(integrant => {
            const saved = savedInspectors.find(value => value.inspectorId === integrant.contingent.id);
            return {
                ...(saved?.id != null ? {id: saved.id} : {}),
                garrisonId: garrison.id,
                inspectorId: integrant.contingent.id,
                inspectorName: integrant.contingent.namewar,
            };
        });
};

export const buildActivityPayload = (state, garrisons, bos) => {
    const garrison = garrisons.map(item => {
        const data = {
            garrisonId: item.id,
            garrisonObservation: item.garrisonObservation,
            inspectors: extractInspectors(item),
        };
        if (item.oldId) data.id = item.oldId;
        return data;
    });

    const preparedBos = bos
        .filter(item => item.bosObservation && item.bosObservation !== "")
        .map(item => {
            const data = {bogcmId: item.bogcmId, bosObservation: item.bosObservation};
            if (item.oldId) data.id = item.oldId;
            return data;
        });

    const model = {
        onDuty: state.onDuty,
        activityObservation: state.activityObservation,
        inspector: state.inspector,
        garrison,
        bos: preparedBos,
    };

    if (state.id) model.systemUpdate = state.systemUpdate;

    return model;
};
